import httpInstance from "@/utils/http";

// 获取个人信息接口
export const GetPersonalDataAPI = (params) => {
    return httpInstance({
        url: `/user/personalMessage?${params}`,
        method: 'GET',
    })
}

// 修改个人信息接口
export const RevisePersonalDataAPI = (data) => {
    return httpInstance({
        url: '/user/personalMessageManage',
        method: 'PUT',
        headers: {
            'Authorization': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbGFpbXMiOnsicGhvbmVOdW1iZXIiOiIoMjApIDk5OTIgMzc2NyIsIm5hbWUiOiJTYW11ZWwgRmxvcmVzIiwidXNlcklkIjoxLCJlbWFpbCI6Inp4MTIzNDU2In0sImV4cCI6MTczNDAzNzM2NX0.E4Fs6ZbcmiajV55EB5nA_8qN5dWsYPrNq__1zUWeQZg',
            'Content-Type': 'application/json'
        },
        data,
    })
}

// 获取用户信息
export const GetUserInfoAPI = () => {
    return httpInstance({
        url: `/user/getUserInfo`,
        method: 'GET',
    })
}   